import { useEffect, useState } from "react";
import "../../assets/common/css/dashboarButton.css";
import { Button, Modal, Spinner } from "react-bootstrap";
import privateApi from "../../services/privateApi";
import swal from "sweetalert";
import "./monthlyUpdate.css";
import ReactDatePicker from "react-datepicker";
import ja from "date-fns/locale/ja";
import moment from "moment";
import { getCurrentMonth } from "../../services/auth/token";
import CourseCalendar from "./course-calendar";

const MonthlyUpdate = () => {
  const [showMonthlyUpdateModal, setShowMonthlyUpdateModal] = useState(false);
  const [showAttendanceGenerateModal, setShowAttendanceGenerateModal] =
    useState(false);

  const [loading, setLoading] = useState(false);
  const [startFrom, setStartFrom] = useState(null);
  const [endTo, setEndTo] = useState(null);
  const [step2, setStep2] = useState(false);

  const formatDate = date => {
    return date.toLocaleDateString("ja", { month: "numeric" });
  };

  // Ensure startFrom is always less than endTo
  useEffect(() => {
    if (startFrom >= endTo) {
      setEndTo(new Date(startFrom?.getTime() + 24 * 60 * 60 * 1000)); // Add one day to startFrom
    }
  }, [startFrom, endTo]);

  const refactorMonth = () => {
    let date = getCurrentMonth();
    let endMonth = getCurrentMonth();
    let month = getCurrentMonth().getMonth();
    date.setMonth(month);
    endMonth.setMonth(month + 1);

    setStartFrom(new Date(date));
    setEndTo(new Date(endMonth));
  };

  const handleUpdateProcess = async () => {
    const data = {
      start_from: startFrom && moment(startFrom).format("YYYY-MM"),
      end_to: endTo && moment(endTo).format("YYYY-MM"),
    };
    setLoading(true);
    const response = await privateApi.post(
      `/admin/generate-members-class-sql`,
      data
    );
    if (response.status === 200) {
      setShowMonthlyUpdateModal(false);
      setLoading(false);

      swal(
        "成功しました！",
        "毎月のプロセスが更新されました！",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      swal(response.data.message, "", "error");
      setShowMonthlyUpdateModal(false);
      setLoading(false);
    }
  };

  const handleAttendaceGenerateRefine = async () => {
    try {
      setLoading(true);
      const response = await privateApi.post(
        `/admin/generateAttendanceRefine`,
        {}
      );
      if (response.status === 200) {
        swal("成功しました！", "毎月の出席者数が発生しました!", "success");
        setShowAttendanceGenerateModal(false);
      } else {
        swal(response.data.message, "", "error");
        setShowAttendanceGenerateModal(false);
      }
    } catch (error) {
      console.error("Error occurred:", error);
      swal("エラーが発生しました！", "もう一度お試しください。", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refactorMonth();
  }, []);

  return (
    <>
      <div className="p-3">
        <p className="headline">月次更新</p>

        <div className="admin-dash btn-container col-md-5">
          <CourseCalendar />
          <div>
            <button
              onClick={() => setShowMonthlyUpdateModal(true)}
              className="dash-btn"
            >
              月次更新処理
            </button>
          </div>
          {localStorage.getItem("showAttendanceGenerateButton") === "yes" && (
            <div>
              <button
                onClick={() => setShowAttendanceGenerateModal(true)}
                className="dash-btn"
              >
                出席を生成する
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Modal for Monthly update process submission */}
      <Modal
        show={showMonthlyUpdateModal}
        onHide={() => setShowMonthlyUpdateModal(false)}
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            月次更新 プロセス
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mxy-auto">
          {step2 ? (
            <>
              {startFrom && endTo && (
                <h5>
                  <strong className="text-danger">
                    {formatDate(startFrom)}
                  </strong>
                  &nbsp; のデータが &nbsp; &nbsp;
                  <strong className="text-danger">{formatDate(endTo)}</strong>
                  &nbsp; にコピーされている
                </h5>
              )}

              <p>本当によろしいですか？</p>
            </>
          ) : (
            <>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>から:</label>
                  <div>
                    <ReactDatePicker
                      className="form-control"
                      selected={startFrom}
                      dateFormat="yyyy/MM"
                      showMonthYearPicker
                      locale={ja}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <label>への:</label>
                  <div>
                    <ReactDatePicker
                      className="form-control"
                      selected={endTo}
                      dateFormat="yyyy/MM"
                      showMonthYearPicker
                      locale={ja}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <h5 className="mt-2 mb-0 text-center">月次更新処理を行う</h5>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {step2 ? (
            <>
              <Button variant="danger" onClick={() => setStep2(false)}>
                前の
              </Button>
              <Button
                variant="success"
                onClick={() => handleUpdateProcess()}
                disabled={loading}
              >
                {loading && (
                  <>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                )}
                {loading ? "お待ちください..." : "確認"}
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="danger"
                onClick={() => setShowMonthlyUpdateModal(false)}
              >
                キャンセル
              </Button>
              <Button variant="success" onClick={() => setStep2(true)}>
                確認
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      {/* Modal for Attendance Generate */}
      <Modal
        show={showAttendanceGenerateModal}
        onHide={() => setShowAttendanceGenerateModal(false)}
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            月次出席率の生成
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{startFrom && formatDate(startFrom)} 出席を生成する</h4>
          <p>本当によろしいですか？</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => handleAttendaceGenerateRefine()}
            disabled={loading}
          >
            {loading && (
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </>
            )}
            {loading ? "お待ちください..." : "確認"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MonthlyUpdate;
